module.exports = __webpack_public_path__ + "fonts/fa-solid-900.27df36c7.ttf";